<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Cadastrar familiar</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <div class="header">
          <img [src]="userPicture" id="coverAvatar" />
          <app-upload-button
            title="Enviar foto"
            color="primary"
            [fileTypes]="['jpeg', 'jpg', 'png', 'gif']"
            (onPictureSelected)="responseAvatar($event)"
          ></app-upload-button>
        </div>
      </ion-col>
      <ion-col size="12" sizeMd="4">
        <ion-item>
          <ion-label position="floating">Nome</ion-label>
          <ion-input
            name="nome"
            type="text"
            [ngModel]="morador.nome"
            (ngModelChange)="morador.nome=$event"
            required
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" sizeMd="4">
        <ion-item>
          <ion-label position="floating">RG</ion-label>
          <ion-input
            name="RG"
            type="text"
            [(ngModel)]="morador.RG"
            maxlength="10"
            required
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" sizeMd="4">
        <ion-item>
          <ion-label position="floating">CPF</ion-label>
          <ion-input
            name="CPF"
            type="text"
            [ngModel]="morador.cpf | cpfMask"
            (ngModelChange)="morador.cpf=$event"
            maxlength="14"
            required
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="12" sizeMd="6">
        <ion-item style="margin-top: -3px">
          <ion-label position="floating">Data Nascimento</ion-label>
          <ion-datetime
            cancelText="Cancelar"
            doneText="Selecionar"
            displayFormat="DD/MM/YYYY"
            value=""
            [(ngModel)]="morador.nascimento"
            required
            (ionChange)="autoriza_menor_idade($event)"
          ></ion-datetime>
        </ion-item>
      </ion-col>
      <ion-col size="12" sizeMd="6">
        <ion-item style="margin-top: 7px;">
          <ion-label>Parentesco</ion-label>
          <ion-select
            [(ngModel)]="morador.parentesco"
            okText="Selecionar"
            placeholder="Selecione"
            cancelText="Cancelar"
          >
            <ion-select-option
              *ngFor="let parentesco of parentescos"
              value="{{ parentesco.id }}"
              >{{ parentesco.descricao | ucFirstLetter }}</ion-select-option
            >
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col size="12" sizeMd="12" [hidden]="maiorDeIdade">
        <ion-item style="margin-top: -3px">
            <ion-checkbox
            slot="start"
            [checked]="morador.autoriza_menor_idade"
            [(ngModel)]="morador.autoriza_menor_idade"
            >
            </ion-checkbox>
            <ion-text>Na qualidade de responsável legal autorizo a coleta e tratamento dos dados pessoais do menor de idade, para a finalidade de cadastro como morador.</ion-text>
        </ion-item>
      </ion-col>

      <ion-col size="12" sizeMd="">
        <ion-item>
          <ion-label>Sexo</ion-label>
          <ion-select
            [(ngModel)]="morador.sexo"
            value=""
            okText="Selecionar"
            placeholder="Selecione"
            cancelText="Cancelar"
          >
            <ion-select-option [value]="1">Masculino</ion-select-option>
            <ion-select-option [value]="0">Feminino</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
      <ion-col size="12" sizeMd="6" [hidden]="true">
        <ion-item style="margin-top: 1px">
          <ion-label>Control Condo</ion-label>
          <ion-toggle [(ngModel)]="morador.usar_control_condo"></ion-toggle>
        </ion-item>
      </ion-col>
      <ion-col size="12" sizeMd="12" *ngIf="morador.usar_control_condo" [hidden]="true">
        <ion-item *ngIf="morador.usar_control_condo">
          <ion-label position="floating">E-mail</ion-label>
          <ion-input
            name="email"
            type="email"
            [(ngModel)]="morador.email"
            required
          ></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>

</ion-content>


<ion-footer>
  <ion-button color="success" expand="block"  (click)="save()">
    <ion-icon name="checkmark-outline" slot="start"></ion-icon>
    Cadastrar familiar
  </ion-button>
</ion-footer>